"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var decentraland_ui_1 = require("decentraland-ui");

var utils_1 = require("../../modules/translation/utils");

var eth_1 = require("../../lib/eth");

var schemas_1 = require("@dcl/schemas");

var ChainProvider_1 = __importDefault(require("../ChainProvider"));

var ChainCheck = /*#__PURE__*/function (_react_1$default$Pure) {
  _inherits(ChainCheck, _react_1$default$Pure);

  function ChainCheck() {
    var _this;

    _classCallCheck(this, ChainCheck);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ChainCheck).apply(this, arguments));

    _this.getChainId = function () {
      var network = _this.props.network;

      try {
        return eth_1.getChainIdByNetwork(network);
      } catch (_a) {
        return null;
      }
    };

    return _this;
  }

  _createClass(ChainCheck, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var children = this.props.children;
      return react_1.default.createElement(ChainProvider_1.default, null, function (data) {
        var isEnabled = data.isSupported || data.chainId === _this2.getChainId();

        return react_1.default.createElement(decentraland_ui_1.Popup, {
          disabled: isEnabled,
          position: "top center",
          content: react_1.default.createElement(utils_1.T, {
            id: "@dapps.button.network_not_supported",
            values: {
              expectedChainName: react_1.default.createElement("b", null, schemas_1.getChainName(eth_1.getConnectedProviderChainId()))
            }
          }),
          trigger: children(isEnabled)
        });
      });
    }
  }]);

  return ChainCheck;
}(react_1.default.PureComponent);

exports.default = ChainCheck;